import { liveUpdateStore } from '../../store/liveUpdateStore';
import { liveUpdateConnection } from '../liveConnection/LiveUpdateConnection';
import { checkHashStore } from '../../store/checkHashStore';
import { DefaultQueryParams } from '../../core/constants/defaultQueryParams';
import { parseQuery } from '../../core/helpers/parseQuery';
import { userInfoStore } from '../../store/userInfoStore';

class LiveUpdateService {
  handleLiveSpinUpdate(data) {
    liveUpdateStore.updateLiveSpinUpdate(data);
  }

  handleGetLiveBetsByGame(data) {
    liveUpdateStore.setLiveSpinsByGame([...data].reverse());
  }

  handleGetHighRollers(data) {
    liveUpdateStore.setHighRollers([...data].reverse());
  }

  handleGetAllLiveBets(data) {
    liveUpdateStore.setAllGamesLiveSpins([...data].reverse());
  }

  handleUpdateHighRoller(data) {
    liveUpdateStore.updateHighRollers(data);
  }

  checkResultHash(params) {
    liveUpdateConnection.checkResultHash(params);
  }

  handleCheckResultHashResult(hash) {
    checkHashStore.setCalculateSaltAndKey({ hash });
  }

  handleSetExchangeAmount(model) {
    const { [DefaultQueryParams.GameId]: gameId } = parseQuery(window.location.search);
    const { userId, setExchangedBetAmount } = userInfoStore;
    if (+gameId === +model.gameId && +userId === +model.userId) {
      setExchangedBetAmount(model.amount);
    }
  }
}

export const liveUpdateService = new LiveUpdateService();
